/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для формы регистрации
   */
  app.SignupFormView = app.CommonAuthFormView.extend({
    el: '#signup-form',
    formName: 'signup',
    formElement: '.field_input',
    additionalOptions: ['districts', 'withHiddenDistrictField'],

    events: {
      'click .button_blue': 'submit',
      'blur .input': 'validate',
      'blur .input_phone': 'changeInfoMessage',
      'change #signup-isAcceptAgreement': 'validate',
      'click .js-gen-pswd': 'generatePassword',
      'focus #signup-city': 'clearInputCity',
      'blur #signup-city': 'blurInputCity'
    },

    run: function () {
      this.childViews = {};
      this.cityInput = this.$el.find('#signup-city');
      this.cityInputValue = '';
      app.CommonAuthFormView.prototype.run.apply(this);
      this.model = new app.SignupForm();
      this.childViews.phoneInputmaskView = new app.PhoneInputmaskView({
        el: this.$('#signup-phone'),
      });
      this.childViews.settlementAutocomplete = new app.SettlementAutocompleteView({
        el: $('#signup-city'),
        settlement: this.settlement,
      });
      this.childViews.choiceCountryView = new app.ChoiceCountryView({'el': this.$('.choice-country')});
      this.settlementModel = new app.Model({
        id: app.settlement.get('settlement_id')
      });
      this.childViews.districtPopupView = new app.DistrictPopupView({
        el: this.$('.district-container'),
        districts: this.districts,
        model: this.settlementModel,
        withHiddenDistrictField: this.withHiddenDistrictField,
      });
      this.listenTo(this.childViews.settlementAutocomplete, 'autocompleteDone', this.updateSettlement);
      this.listenTo(Backbone, 'change-city-signup', this.renderCity);
      this.renderCity(this.settlement, null);
    },
    /**
     * Отрисовка названия города
     * @param {Object} settlement Модель населенного пункта
     * @param {Object} districts Коллекция районов города
     */
    renderCity: function (settlement, districts) {
      var settlementId = settlement.get('settlement_id'),
        districtId = settlement.get('district_id');
      this.childViews.districtPopupView.checkDistrict(settlementId, districtId, districts);
      this.settlementModel.set('id', settlementId);
      this.cityInput.val(app.helpers.StringHelper.getSettlementString(settlement));
      this.cityInputValue = this.cityInput.val();
    },
    /**
     * Меняет надпись под формой ввода телефона в зависимости от того мобильный номер или нет
     */
    changeInfoMessage: function (event) {
      var start = app.countryFlag.attributes.code.length - 1,
        end = start + 3,
        phoneCode = parseInt($(event.target).val().substring(start, end)),
        phoneNumberLength = $(event.target).val().length,
        checkForMobile = app.helpers.isMobileHelper.isMobile(phoneCode, phoneNumberLength),
        callAndSms = this.$('.call-and-sms'),
        onlyCall = this.$('.only-call');
      if (checkForMobile) {
        callAndSms.show();
        onlyCall.hide();
        return;
      }
      callAndSms.hide();
      onlyCall.show();
    },
    /**
     * Обновление населенного пункта при автокомплите
     * @param {number} id Id населенного пункта
     * @param {app.Model} model модель населенного пункта
     */
    updateSettlement: function (id, model) {
      this.childViews.districtPopupView.checkDistrict(id);
      if (model) {
        this.cityInputValue = app.helpers.StringHelper.getSettlementString(model);
        this.settlementModel.set('id', model.get('id'));
      }
    },
    clearInputCity: function () {
      this.cityInput.val('');
    },
    blurInputCity: function () {
      this.cityInput.val(this.cityInputValue);
    },
    /**
     *  Генерирует пароль для пользователя
     */
    generatePassword: function () {
      var length = 8,
        charset = 'abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
        password = '';
      for (var i = 0, n = charset.length; i < length; ++i) {
        password += charset.charAt(Math.floor(Math.random() * n));
      }
      this.$('#signup-password').val(password);
    }
  });
})(jQuery);

}.call(window));